function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("metadata", null);
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeWidth: 0.99999
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m8.3927 30.164c-4.2616-1.1966-6.7299-5.5647-5.513-9.7561 0.432-1.4885 1.2998-2.8191 2.4948-3.8265l5.2216 5.9933z",
  fill: "#adb9ca"
}), React.createElement("path", {
  d: "m15.927 16.676c3.3124 2.8959 3.6107 7.8846 0.66626 11.143-2.0487 2.2669-5.2367 3.1784-8.2017 2.3454l2.2041-7.5891z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m5.3923 16.566c3.0555-2.5597 7.5639-2.5055 10.555 0.12685l-5.351 5.8816z",
  fill: "#ecaec6"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m23.636 17.194c3.0326-3.1784 8.1111-3.3372 11.343-0.35428 1.1476 1.0594 1.9532 2.4272 2.3164 3.9333l-7.8078 1.822z",
  fill: "#adb9ca"
}), React.createElement("path", {
  d: "m32.379 29.957c-4.1341 1.5707-8.7801-0.45239-10.377-4.5185-1.1109-2.8291-0.47558-6.0342 1.6348-8.2454l5.851 5.4014z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m37.301 20.795c0.91489 3.8436-1.198 7.761-4.9467 9.1712l-2.8666-7.3718z",
  fill: "#ecaec6"
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.99999
}, React.createElement("path", {
  d: "m8.3672 30.146 2.2056-7.5945 5.3437-5.8645",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "m5.3744 16.581 5.1981 5.9703",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m4.5024 27.71c-2.8837-3.3102-2.4933-8.2927 0.87206-11.129 3.3656-2.8362 8.4315-2.4522 11.315 0.85796 2.8837 3.3099 2.4933 8.2924-0.87232 11.129-3.3653 2.8362-8.4312 2.4522-11.315-0.85771z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "m23.664 17.18 5.8553 5.4054 2.8545 7.3574",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "m37.296 20.773-7.7765 1.8122",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m27.635 14.915c4.3122-1.0061 8.6373 1.6163 9.6602 5.8575 1.0232 4.2412-1.6434 8.4953-5.9556 9.5014-4.3122 1.0061-8.6373-1.6163-9.6602-5.8575-1.023-4.2412 1.6434-8.4951 5.9556-9.5014z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m20.061 7.4915c1.8427 0.018697 3.613 0.62311 5.063 1.6997l1.0484 0.96659 2.0325-1.5597-0.13154 4.9821-4.9261-1.101 1.6551-1.2701-1.9252-1.4357c-0.87899-0.40312-1.8433-0.62339-2.8335-0.63356-0.99021-0.010175-1.9589 0.19056-2.846 0.57582l-2.0718 1.4802 1.6724 1.2833-4.9261 1.101-0.13154-4.9821 2.0224 1.552 1.2-1.0617c1.4721-1.0471 3.2548-1.6155 5.0978-1.5968z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var SvgMenuComparisonIcon = function SvgMenuComparisonIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuComparisonIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-comparison-icon.bc0c67aa.svg";
export { ForwardRef as ReactComponent };